import { oc } from '@orpc/contract';
import { computeValuationInputSchema, computeValuationOutputSchema } from '../schemas/valuations.schemas.js';
/**
 * Prices the record as it stands, without writing anything. The estimator calls it on load and after
 * every save; the browser runs the same engine locally in between, so the number never lags a keystroke
 * (plan §2.5).
 */
export const computeValuationContract = oc
    .route({
    method: 'POST',
    path: '/valuations/compute',
    tags: ['Valuations'],
    summary: 'Run the published policy over an estimate or a stock vehicle',
})
    .input(computeValuationInputSchema)
    .output(computeValuationOutputSchema);
//# sourceMappingURL=compute-valuation.contract.js.map